var React = require('react');

function BracketOpen (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path_613"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Group-384","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("path",{"d":"M15.658,0 C6.83243591,10.4346634 1.94554681,23.6338642 1.848,37.3 C1.84142927,44.1880214 3.10873911,51.0178653 5.586,57.445 C7.92908157,63.7009958 11.3366477,69.5045492 15.658,74.599 L0,74.599 L0,-0.001 L15.658,0 Z","id":"Path_613"})))]);
}

BracketOpen.defaultProps = {"width":"16px","height":"75px","viewBox":"0 0 16 75","version":"1.1"};

module.exports = BracketOpen;

BracketOpen.default = BracketOpen;
